module.exports = __webpack_public_path__ + "img/addon-visitor-management.da7792e1.png";